<div class="metric-card" [ngClass]="['size-' + size, 'semantic-' + semantic]">

  <div class="card-header">
    <span class="card-title">{{ title }}</span>
    <app-info-tooltip *ngIf="tooltipTerm || tooltipText"
                      [term]="tooltipTerm!"
                      [text]="tooltipText!"
                      [size]="11">
    </app-info-tooltip>
  </div>

  <div class="card-value">
    <span class="value-number">{{ displayValue }}</span>
    <span class="value-suffix" *ngIf="suffix && hasValue">{{ suffix }}</span>
  </div>

  <div class="card-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
</div>
